import writeXlsxFile from "write-excel-file";
import format from "date-fns/format";
import { getModifiedDate } from "../helperFuncs";

export const GenerateLoadsDownload = async (
  loads,
  jobName,
  type,
  projectVendorInvoices,
  projectCustomerInvoices,
  accountCustomerInvoices,
  accountVendorInvoices,
) => {
  if (loads && type && jobName) {
    // replace periods from job name and invoice name
    const newJobName = jobName.replace(/\./g, "-");
    const InvoiceName = (invId, isCustomer) => {
      var invoiceName = ""
      if (projectCustomerInvoices && projectVendorInvoices) {
        let invoice = [];
        if (isCustomer && invId !== 0) {
          invoice = projectCustomerInvoices.filter((x) => x.id === invId);
        } else if (
          projectVendorInvoices.invoices &&
          !isCustomer &&
          invId !== 0
        ) {
          invoice = projectVendorInvoices.invoices.filter(
            (x) => x.id === invId,
          );
        }
        if (invoice.length > 0) {
          invoiceName =  invoice[0].invoice_name;
        } else {
          invoiceName = "";
        }
      }
      if (accountCustomerInvoices && accountVendorInvoices && invoiceName === "") {
        let invoice = [];
        if (isCustomer && invId !== 0) {
          invoice = accountCustomerInvoices.filter((x) => x.id === invId);
        } else if (
          !isCustomer &&
          invId !== 0
        ) {
          invoice = accountVendorInvoices.filter(
            (x) => x.id === invId,
          );
        }
        if (invoice.length > 0) {
          invoiceName =  invoice[0].invoice_name;
        } else {
          invoiceName = "";
        }
      }
      return invoiceName
    };

    // parse delivered date
    const ErrorHandler = (error) => {
      return error.message;
    };

    const DeliveredOn = (d) => {
      try {
        var newD = getModifiedDate(d);
        return format(Date.parse(newD), "MM/dd/yy hh:mm a");
      } catch (error) {
        return ErrorHandler(error);
      }
    };

    const columns = [
      { width: 10 },
      { width: 30 },
      { width: 20 },
      { width: 30 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];
    const blankRow = [{}];

    const data = [blankRow];

    const totals = {
      loads: 0,
      weight_tons: 0,
      freight_rev: 0,
      freight_cost: 0,
      fsc_rev: 0,
      fsc_cost: 0,
      sand_rev: 0,
      sand_cost: 0,
      total_cost: 0,
      total_rev: 0,
    };
    // loads
    const loadsHeader = [
      {},
      {
        value: "Load No",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Delivery Date",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Carrier",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Driver",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Terminal",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Product",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "PO Number",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Ticket No",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Approved Mileage",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Net Weight (tons)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Freight Rev ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Freight Cost ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Fuel Surcharge Rev ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Fuel Surcharge Cost ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Sand Rev ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Sand Cost ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Total Rev ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Total cost ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Status",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Customer Invoice",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Vendor Invoice",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
    ];
    data.push(loadsHeader);

    loads.forEach((load) => {
      let delivered = DeliveredOn(load.delivered_date);

      let newLoad = [
        {},
        {
          value: load.load_no,
          fontSize: 12,
          align: "center",
        },
        {
          value: delivered,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.carrier_name,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.driver_name,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.terminal_name,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.product_name,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.po_number,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.ticket_number,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.approved_mileage,
          fontSize: 12,
          align: "center",
        },
        {
          value: parseFloat(load.weight_tons.toFixed(2)),
          fontSize: 12,
          align: "center",
        },
        {
          value: parseFloat(load.freight_rev.toFixed(2)),
          fontSize: 12,
          align: "center",
        },
        {
          value: parseFloat(load.freight_cost.toFixed(2)),
          fontSize: 12,
          align: "center",
        },
        {
          value: parseFloat(load.fsc_rev.toFixed(2)),
          fontSize: 12,
          align: "center",
        },
        {
          value: parseFloat(load.fsc_cost.toFixed(2)),
          fontSize: 12,
          align: "center",
        },
        {
          value: parseFloat(load.sand_rev.toFixed(2)),
          fontSize: 12,
          align: "center",
        },
        {
          value: parseFloat(load.sand_cost.toFixed(2)),
          fontSize: 12,
          align: "center",
        },
        {
          value: parseFloat(
            (load.freight_rev + load.fsc_rev + load.sand_rev).toFixed(2),
          ),
          fontSize: 12,
          align: "center",
        },
        {
          value: parseFloat(
            (load.freight_cost + load.fsc_cost + load.sand_cost).toFixed(2),
          ),
          fontSize: 12,
          align: "center",
        },
        {
          value: load.propconnect_approval_status,
          fontSize: 12,
          align: "center",
        },
        {
          value: InvoiceName(load.customer_invoice_id, true),
          fontSize: 12,
          align: "center",
        },
        {
          value: InvoiceName(load.vendor_invoice_id, false),
          fontSize: 12,
          align: "center",
        },
      ];
      data.push(newLoad);
      totals.loads = totals.loads + 1;
      totals.weight_tons = totals.weight_tons + load.weight_tons;
      totals.freight_rev = totals.freight_rev + load.freight_rev;
      totals.freight_cost = totals.freight_cost + load.freight_cost;
      totals.fsc_rev = totals.fsc_rev + load.fsc_rev;
      totals.fsc_cost = totals.fsc_cost + load.fsc_cost;
      totals.sand_rev = totals.sand_rev + load.sand_rev;
      totals.sand_cost = totals.sand_cost + load.sand_cost;
      totals.total_rev =
        totals.total_rev + load.freight_rev + load.fsc_rev + load.sand_rev;
      totals.total_cost =
        totals.total_cost + load.freight_cost + load.fsc_cost + load.sand_cost;
    });

    const loadTotals = [
      {
        value: "Totals",
        fontSize: 12,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: totals.loads,
        fontSize: 12,
        align: "center",
        fontWeight: "bold",
      },
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {
        value: totals.weight_tons.toFixed(2),
        fontSize: 12,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: totals.freight_rev.toFixed(2),
        fontSize: 12,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: totals.freight_cost.toFixed(2),
        fontSize: 12,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: totals.fsc_rev.toFixed(2),
        fontSize: 12,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: totals.fsc_cost.toFixed(2),
        fontSize: 12,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: totals.sand_rev.toFixed(2),
        fontSize: 12,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: totals.sand_cost.toFixed(2),
        fontSize: 12,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: totals.total_rev.toFixed(2),
        fontSize: 12,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: totals.total_cost.toFixed(2),
        fontSize: 12,
        align: "center",
        fontWeight: "bold",
      },
    ];
    data.push(loadTotals);
    await writeXlsxFile(data, {
      columns,
      fileName: `${newJobName} - ${type}`,
    });
  }
};
